export const cleanFormData = <T>(value: T): T => {
  if (value === null || value === undefined) {
    return null as T;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    return (trimmed.length === 0 ? null : trimmed) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => cleanFormData(item)) as unknown as T;
  }

  if (typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, cleanFormData(v)]),
    ) as T;
  }

  return value;
};
